module.exports = __webpack_public_path__ + "img/cost-icon__camastros.167af1d3.svg";